import { toDigitsOnly } from '@sravni/creditselection-customer-utils/lib/utils/customers';

export class LastWorkExperience {
  private readonly lastWorkExperienceStartMonth: string | undefined;
  private readonly lastWorkExperienceStartYear: string | undefined;

  constructor(lastWorkExperience: string | undefined | null) {
    const [month, year] = lastWorkExperience?.split('.') || [];
    this.lastWorkExperienceStartMonth = toDigitsOnly(month) || undefined;
    this.lastWorkExperienceStartYear = toDigitsOnly(year) || undefined;
  }

  month() {
    return this.lastWorkExperienceStartMonth;
  }

  year() {
    return this.lastWorkExperienceStartYear;
  }

  map() {
    const lastWorkExperienceStartMonth = this.month();
    const lastWorkExperienceStartYear = this.year();
    return {
      lastWorkExperienceStartMonth: lastWorkExperienceStartYear ? lastWorkExperienceStartMonth : undefined,
      lastWorkExperienceStartYear,
    };
  }
}
